import { render } from "./CustomOptionSelector.vue?vue&type=template&id=9ef1da1c&scoped=true"
import script from "./CustomOptionSelector.vue?vue&type=script&lang=js"
export * from "./CustomOptionSelector.vue?vue&type=script&lang=js"

import "./CustomOptionSelector.vue?vue&type=style&index=0&id=9ef1da1c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef1da1c"]])

export default __exports__